/* global u */
/**
 * [initSubmitButtons description]
 * @return {[type]} [description]
 */
function initSubmitButtons(selector, context) {

  if (typeof context === 'undefined') {
    context = document;
  }

  if (typeof selector === 'undefined' || !!selector) {
    selector = '.js-auto-disable';
  }

  const auto_disable_submits = u(selector, context);
  auto_disable_submits.map(auto_disable_submit => {
    const form = auto_disable_submit.closest('form');

    if (form.length) {
      auto_disable_submit.setAttribute('disabled', 'disabled');
      const inputs = u('input:not([type="submit"]), select, textarea', form);

      inputs.on(['change', 'keyup'], (e) => {
        auto_disable_submit.removeAttribute('disabled');
      });
    }

    auto_disable_submit.classList.remove('js-auto-disable');
  });
}

export default initSubmitButtons;